import { createSelector } from 'reselect';

const selectAgentLocationTrackers = (state: any) => state.agentLocationTrackers;

export const selectAgentLocationTrackersCurrentItem = createSelector([selectAgentLocationTrackers], (agentLocationTrackers) => agentLocationTrackers.current);

export const selectAgentLocationTrackersListItems = createSelector([selectAgentLocationTrackers], (agentLocationTrackers) => agentLocationTrackers.list);


export const selectAgentLocationTrackersItemById = (itemId: any) =>
    createSelector(selectAgentLocationTrackersListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAgentLocationTrackersQueryItems = createSelector([selectAgentLocationTrackers], (agentLocationTrackers) => agentLocationTrackers.query);

export const selectAgentLocationTrackersCreatedItem = createSelector([selectAgentLocationTrackers], (agentLocationTrackers) => agentLocationTrackers.create);

export const selectAgentLocationTrackersUpdatedItem = createSelector([selectAgentLocationTrackers], (agentLocationTrackers) => agentLocationTrackers.update);

export const selectAgentLocationTrackersReadItem = createSelector([selectAgentLocationTrackers], (agentLocationTrackers) => agentLocationTrackers.read);

export const selectAgentLocationTrackersDeletedItem = createSelector([selectAgentLocationTrackers], (agentLocationTrackers) => agentLocationTrackers.delete);

export const selectAgentLocationTrackersSearchedItems = createSelector([selectAgentLocationTrackers], (agentLocationTrackers) => agentLocationTrackers.search);

export const selectAgentLocationTrackersItemsCount = createSelector([selectAgentLocationTrackers], (agentLocationTrackers) => agentLocationTrackers.count);

export const selectAgentLocationTrackersItemsFilter = createSelector([selectAgentLocationTrackers], (agentLocationTrackers) => agentLocationTrackers.filter);